import React, { useMemo } from 'react';
import EditableSelect from 'components/UI/Input/EditableSelect';
import EditableTextInput from 'components/UI/Input/EditableTextInput';
import PropTypes from 'prop-types';
import { LOCATIONS } from 'constants/locations';

function StateInput({
    country, isLoading, value, onChange, error,
})
{
    const countriesWithStatesList = [
        'United States', 'Canada',
    ];

    const statesList = useMemo(() =>
    {
        const list = [];
        switch (country)
        {
            case 'United States':
                list.push(...LOCATIONS.US_STATES);
                break;
            case 'Canada':
                list.push(...LOCATIONS.CANADA_STATES);
                break;
            default:
                break;
        }
        return list;
    }, [country]);

    const handleSelectChange = (option) =>
    {
        if (!option) return;

        if (option?.label)
        {
            onChange(option.label, 'state');
        }
        else
        {
            onChange(option, 'state');
        }
    };

    return (
        (country && countriesWithStatesList.includes(country)) ? (
            <EditableSelect
                editing={!isLoading}
                containerClassName="tw-flex-wrap tw-mb-3"
                labelContainerClassName="tw-flex-auto tw-w-full"
                inputProps={{
                    getOptionLabel: (option) => option?.label ?? value,
                    getOptionValue: (option) => option.label,
                    options: statesList.map((state) => ({ label: state.label, value: state.label })) ?? [],
                    placeholder: 'Select state',
                    onChange: handleSelectChange,
                    error,
                }}
                labelText="State"
            />
        ) : (
            <EditableTextInput
                editing={!isLoading}
                text={value}
                inputProps={{
                    path: 'state',
                    error,
                    onChange,
                }}
                labelText="State"
            />
        )
    );
}

StateInput.propTypes = {
    country: PropTypes.string,
    isLoading: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.string,
};

export default StateInput;
